import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { ReporteUACComponent } from './reporte-UAC.component';

const routes: Routes = [
  { path: '', component: ReporteUACComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class ReporteUACRouting { }
